<template lang="html">
  <div class="cw-invoice-list">
    <cw-invoice-cell
      v-for="invoice in invoices"
      :invoice="invoice"
      :displayPaymentInfo="displayPaymentInfo"
      :key="invoice.id"
      @click="selectionHandler(invoice)"
    ></cw-invoice-cell>
  </div>
</template>

<script>
export default {
  name: 'cw-invoice-list',
  props: {
    invoices: {
      type: Array,
      required: true,
    },
    displayPaymentInfo: {
      type: Boolean,
      default: false,
    },
    selectionHandler: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
};
</script>

<style lang="" scoped></style>
